import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {

    year: number;

    constructor() {
        const date = new Date();
        this.year = date.getFullYear();
    }

}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/components/app-footer/app-footer.component.ts